import classNames from 'classnames/bind';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

export function NextArrow(props) {
  const {
    className, onClick, section,
  } = props;
  const nextArrowClass = cx(className, 'right_arrow',
    {
      logo: section === 'logos',
    });
  return (
    <div
      className={nextArrowClass}
      onClick={onClick}
    />
  );
}

export function PrevArrow(props) {
  const {
    className, onClick, section,
  } = props;
  const prevArrowClass = cx(className, 'left_arrow',
    {
      logo: section === 'logos',
    });
  return (
    <div
      className={prevArrowClass}
      onClick={onClick}
    />
  );
}
